module.exports = __webpack_public_path__ + "files/db358f7aa96d1d261db62488de7d858a.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/windows_dark.png
// module id = 934
// module chunks = 76